import React from "react";

function expencesdate(props) {
  const day = props.date.toLocaleString("en-US", { day: "2-digit" });
  const month = props.date.toLocaleString("en-US", { month: "short" });
  const year = props.date.getFullYear();
  return (
    <div>
      <div>{day}-{month}-{year}</div>
    </div>
  );
}

export default expencesdate;
